import { useState } from "react";
import { TypedFilter } from "odata-query";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import {
  IApiRequest,
  IInspectionTemplateListItemResponse,
} from "@miplatform/types";
import { createUUID } from "@miplatform/utils";

const getInspectionTemplatesUUID = createUUID();
const getRecentInspectionTemplatesUUID = createUUID();

export const useInspectionTemplates = ({
  module = null,
}: IUseInspectionTemplatesProps = {}) => {
  const [inspectionTemplates, setInspectionTemplates] = useState<
    IInspectionTemplateListItemResponse[]
  >([]);
  const [recentInspectionTemplates, setRecentInspectionTemplates] = useState<
    IInspectionTemplateListItemResponse[]
  >([]);
  const [filter, setFilter] = useState<
    TypedFilter<IInspectionTemplateListItemResponse>
  >({});

  const stateManager = useComponentState();

  const getInspectionTemplates = ({
    top,
    skip,
    search = "",
  }: IApiRequest = {}) => {
    stateManager.abort(getInspectionTemplatesUUID);
    return stateManager.run(async () => {
      const response = await taskService.inspectionTemplates.getAll({
        top,
        skip,
        filters: {
          ...filter,
          name: { contains: search },
          ...(module ? { module: { eq: module } } : {}),
        },
        sort: "name",
      });

      if (response.status === HTTP_STATUSES.OK) {
        setInspectionTemplates(response.data);
      }
      return response;
    });
  };

  const getRecentInspectionTemplates = ({
    sort,
    top,
    filters,
  }: IApiRequest = {}) => {
    return stateManager.run(async () => {
      const response = await taskService.inspectionTemplates.getAll({
        sort,
        top,
        filters: {
          ...filter,
          ...filters,
          ...(module ? { module: { eq: module } } : {}),
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        setRecentInspectionTemplates(response.data);
      }
      return response;
    }, getRecentInspectionTemplatesUUID);
  };

  return {
    isLoading: stateManager.isBusy(),
    inspectionTemplates,
    recentInspectionTemplates,
    getInspectionTemplates,
    getRecentInspectionTemplates,
    filter,
    setFilter,
  };
};

interface IUseInspectionTemplatesProps {
  module?: string | null;
}
